import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { AdminCommunicationService } from '@services/communication/communication.service';
import { LocalStorageService } from '@services/local-storage/local-storage.service';
import { NotificationService } from '@services/notification.service';
import { AddPropertyAccessService } from '@services/add-property-access/add-property-access.service';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  imports: [RouterModule, CommonModule],
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class Header {

  userDetails: any = {};
  notificationCount : number = 0;
  totalUnreadCount$!: Observable<number>;
  currentUrl = '';
  activeTab: 'home' | 'property' | 'tenant' | 'payment' | 'add-property' | 'move-out' | 'profile' | 'communication' | 'notification' | '' = '';

  constructor(
    private _router: Router,
    private readonly _localStorageService: LocalStorageService,
    private notificationService: NotificationService,
    private chatService: AdminCommunicationService,
    private readonly addPropertyAccess: AddPropertyAccessService,
  ) {
  }

  openAddProperty(): void {
    void this.addPropertyAccess.openAddProperty();
  }

  private isActiveRoute(path: string): boolean {
    const url = this.currentUrl || this._router.url;
    const normalizedUrl = url.split('?')[0].replace(/^\//, '');

    if (path === 'home') {
      return normalizedUrl === 'user/homepage' || normalizedUrl === 'user/home';
    }

    if (path === 'property') {
      return normalizedUrl.startsWith('user/properties') || normalizedUrl.startsWith('user/property-details') || normalizedUrl.startsWith('user/update-property');
    }

    if (path === 'tenant') {
      return normalizedUrl === 'user/tenant' || normalizedUrl.startsWith('user/tenants') || normalizedUrl.startsWith('user/tenant/');
    }

    if (path === 'payment') {
      return normalizedUrl.startsWith('user/payment-dashboard') || normalizedUrl.startsWith('user/all-payments') || normalizedUrl.startsWith('user/payments');
    }

    if (path === 'add-property') {
      return normalizedUrl.startsWith('user/add-property');
    }

    if (path === 'move-out') {
      return normalizedUrl.startsWith('user/tenant-move-out-management');
    }

    return false;
  }

  private setActiveTabFromUrl() {
    if (this.isActiveRoute('home')) {
      this.activeTab = 'home';
    } else if (this.isActiveRoute('property')) {
      this.activeTab = 'property';
    } else if (this.isActiveRoute('move-out')) {
      this.activeTab = 'move-out';
    } else if (this.isActiveRoute('tenant')) {
      this.activeTab = 'tenant';
    } else if (this.isActiveRoute('payment')) {
      this.activeTab = 'payment';
    } else if (this.isActiveRoute('add-property')) {
      this.activeTab = 'add-property';
    } else {
      this.activeTab = '';
    }
  }

  ngOnInit() {
    this._localStorageService.user$.subscribe(user => {
      this.userDetails = user ?? {};
      this.userDetails.profileImage ||= '/images/user.png';
    });
    this.notificationService.notificationCount$.subscribe(count => {
      this.notificationCount = count;
    });
    if (this.userDetails.userId) {
      this.totalUnreadCount$ = this.chatService.getTotalUnreadCount(this.userDetails?.userId);
    }

    this.setActiveTabFromUrl();

    this._router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.currentUrl = this._router.url;
      this.setActiveTabFromUrl();
    });

    this.currentUrl = this._router.url;
  }
}
